import * as THREE from 'three';


export class CausticMaterial extends THREE.ShaderMaterial {
  constructor(baseTexture: THREE.Texture, baseEmissive: THREE.Color, baseDiffuse: THREE.Color, speed: number, useAOApproximation:boolean = false, noiseScale:number = 0.8, causticTexScale:number = 1.5) {

    
    const uniforms = {
      time: { type: 'f', value: 0.0 },
      speed: { type: 'f', value: speed },
      useAoApproximation: { type: 'b', value: useAOApproximation },
      baseEmissive: { type: 'c', value: baseEmissive },
      baseDiffuse: { type: 'c', value: baseDiffuse },
      baseTexture: { type: 't', value: baseTexture },
      noiseScale : { type: 'f', value: noiseScale },
      causticTexScale : { type: 'f', value: causticTexScale }
    };

    const vertexShader = `
      varying vec2 vUv;
      varying vec3 vWorldPosition;
      varying vec3 vNormal;
    

      void main() {
        vUv = uv;
        vec4 worldPosition = modelMatrix * vec4(position, 1.0);
        vWorldPosition = worldPosition.xyz;
        vNormal = normalize(normal * normalMatrix);
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
      }
    `;

    const fragmentShader = `
    vec3 mod289(vec3 x) {
        return x - floor(x * (1.0 / 289.0)) * 289.0;
      }

      float rand(vec2 n) { 
        return fract(sin(dot(n, vec2(12.9898, 4.1414))) * 43758.5453);
      }
      
      vec2 mod289(vec2 x) {
        return x - floor(x * (1.0 / 289.0)) * 289.0;
      }
      
      vec3 permute(vec3 x) {
        return mod289(((x*34.0)+1.0)*x);
      }
      
      float snoise(vec2 p)
      {
        vec2 ip = floor(p);
        vec2 u = fract(p);
        u = u*u*(3.0-2.0*u);
        
        float res = mix(
        mix(rand(ip),rand(ip+vec2(1.0,0.0)),u.x),
        mix(rand(ip+vec2(0.0,1.0)),rand(ip+vec2(1.0,1.0)),u.x),u.y);
        return res*res;
      }

      uniform float time;
      uniform float speed;
      uniform float noiseScale;
      uniform float causticTexScale;
      uniform vec3 baseEmissive;
      uniform vec3 baseDiffuse;
      uniform sampler2D baseTexture;
      uniform bool useAoApproximation;

      varying vec2 vUv;
      varying vec3 vWorldPosition;
      varying vec3 vNormal;

      void main() {

        vec2 realUv = vUv;
        // calc the distance from the center
        vec2 center = vec2(0.5, 0.5);
        float dist = distance(realUv, center);

        vec2 uv = vec2(vWorldPosition.z, vWorldPosition.x) * noiseScale;;
        float noiseValue = snoise(uv + time * speed * 3.5);
        vec2 distortedUv = uv + noiseValue * 0.1;

        vec3 texColor = texture2D(baseTexture, distortedUv).xyz * causticTexScale;
        texColor = pow(texColor, vec3(0.5));
        
        vec4 finalColor;
        if (!useAoApproximation) {
           finalColor = vec4(baseDiffuse + (vec3(1,1,1) * texColor) , (texColor.r* 0.3) );
        }
        else {
           finalColor = vec4(baseDiffuse + (vec3(1,1,1) * texColor) , (texColor.r* 0.3) *  clamp((1.0 - dist * 2.0), 0.0, 1.0));
        }
        
        gl_FragColor = finalColor ; 
      }
    `;

    super({ uniforms, vertexShader, fragmentShader , side: THREE.DoubleSide, transparent: true, blending: THREE.AdditiveBlending});

    this.name = 'CausticMaterial';
    
  }

  public updateBaseColor(newColor: THREE.Color): void {
    if (this.uniforms.baseDiffuse) {
      this.uniforms.baseDiffuse.value = newColor;
    }
  }

  // Update the time uniform. Call this method in your animation loop.
  public updateTime(delta: number): void {
    if (this.uniforms.time) {
      this.uniforms.time.value += 0.005;
    }
  }
}
